<div class="citation-detail">
  <p class="citation-detail-statement">
    <span class="citation-detail-chip">[{{ citation().marker }}]</span>
    {{ citation().statement }}
  </p>

  @for (step of _steps(); track step.step_index) {
    <section class="citation-detail-step">
      <h4 class="citation-detail-step-title">
        {{ chatWordings.citationStep() }} {{ step.step_index }} —
        {{ step.worker_name }}
      </h4>

      @for (item of step.items; track $index) {
        <div class="citation-detail-evidence">
          <div class="citation-detail-evidence-head">
            <span class="citation-detail-evidence-tool">{{ item.tool }}</span>
            @if (item.label) {
              @if (item.labelIsRaw) {
                <code class="citation-detail-evidence-label-raw">{{
                  item.label
                }}</code>
              } @else {
                <span class="citation-detail-evidence-label">{{
                  item.label
                }}</span>
              }
            }
            @if (item.technicalJson) {
              <span
                class="citation-detail-evidence-info"
                [tooltip]="item.technicalJson"
                >{{ chatWordings.citationTechnicalDetails() }}</span
              >
            }
          </div>

          @switch (item.view.kind) {
            @case ('table') {
              <ng-container
                [ngTemplateOutlet]="tableTpl"
                [ngTemplateOutletContext]="{ table: item.view.table, step }"
              />
            }
            @case ('composite') {
              @if (item.view.entries.length > 0) {
                <dl class="citation-detail-kv">
                  @for (entry of item.view.entries; track entry.key) {
                    <div class="citation-detail-kv-row">
                      <dt>{{ entry.key }}</dt>
                      @if (entry.isJson) {
                        <dd>
                          <pre class="citation-detail-kv-json">{{
                            entry.value
                          }}</pre>
                        </dd>
                      } @else {
                        <dd>{{ entry.value }}</dd>
                      }
                    </div>
                  }
                </dl>
              }
              @for (table of item.view.tables; track table.key) {
                <ng-container
                  [ngTemplateOutlet]="tableTpl"
                  [ngTemplateOutletContext]="{ table, step }"
                />
              }
            }
            @case ('raw') {
              <pre class="citation-detail-evidence-result">{{
                item.view.text
              }}</pre>
            }
          }
        </div>
      }
    </section>
  }
</div>

<ng-template #tableTpl let-table="table" let-step="step">
  <div class="citation-detail-table-wrap">
    @if (table.label) {
      <p class="citation-detail-table-label">{{ table.label }}</p>
    }
    <myre-sheet
      [content]="_isExpanded(step, table) ? table.sheet : table.previewSheet"
    />
    @if (_hasFooter(table)) {
      <p class="citation-detail-table-more">
        <span>
          {{ _shownRows(step, table) }} /
          {{ table.totalItems ?? table.rowCount }}
          {{ chatWordings.citationRows() }}
          @if (_isCapped(table)) {
            <span
              class="citation-detail-evidence-info"
              [tooltip]="chatWordings.citationExcerptTooltip()"
              >ⓘ</span
            >
          }
        </span>
        @if (_isExpandable(table)) {
          <button
            class="citation-detail-table-toggle"
            type="button"
            (click)="_toggleTable(step, table)"
          >
            {{
              _isExpanded(step, table)
                ? chatWordings.citationShowLess()
                : (_isCapped(table)
                    ? chatWordings.citationShowExcerpt()
                    : chatWordings.citationShowAll()) +
                  ' (' +
                  table.rowCount +
                  ')'
            }}
          </button>
        }
      </p>
    }
  </div>
</ng-template>
